import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2e6f798c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2e6f798c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6f798c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e6f798c')) {
      api.createRecord('2e6f798c', component.options)
    } else {
      api.reload('2e6f798c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2e6f798c&scoped=true", function () {
      api.rerender('2e6f798c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/order/index.vue"
export default component.exports